import React, { useEffect, useState, useRef } from 'react';
import { ClockCircleOutlined } from '@ant-design/icons';

interface CountdownTimerProps {
  onTimeout: () => void;
  initialTime: number;
  onGetTime?: (time: number) => void;
}

const TimerPrepare: React.FC<CountdownTimerProps> = ({ onTimeout, initialTime, onGetTime }) => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  useEffect(() => {
    setTimeLeft(initialTime);
  }, [initialTime]);

  useEffect(() => {
    if (onGetTime) onGetTime(timeLeft);
  }, [timeLeft]);

  useEffect(() => {
    if (timerRef.current) clearInterval(timerRef.current);

    if (timeLeft > 0) {
      timerRef.current = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timerRef.current!);
            onTimeout();
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [timeLeft]); // Chạy lại khi `timeLeft` thay đổi

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${String(minutes).padStart(2, '0')}:${String(secs).padStart(2, '0')}`;
  };

  return (
    <div className="flex items-center space-x-2">
      <ClockCircleOutlined className="text-base" />
      <p className="text-left text-sm font-medium">{formatTime(timeLeft)}</p>
    </div>
  );
};

export default TimerPrepare;
